import { __assign } from 'tslib';
import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconPosition } from '../KKeycloakGuestAuthButton/types.js';

var StyledKKeycloakCredentialAuthButton = styled(ButtonBase, {
    shouldForwardProp: function (prop) { return prop !== "adminButtonStyle" && prop !== "convertThemeColor"; }
})(function (_a) {
    var theme = _a.theme, adminButtonStyle = _a.adminButtonStyle, convertThemeColor = _a.convertThemeColor;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "space-between", padding: theme.spacing(4), backgroundColor: theme.palette.grey[100], borderTop: "1px solid ".concat(theme.palette.grey[400]) }, (adminButtonStyle && {
        width: adminButtonStyle.width ? adminButtonStyle.width : "",
        margin: adminButtonStyle.width ? "auto" : "unset",
        justifyContent: adminButtonStyle.iconPosition === IconPosition.Left ? "flex-start" : "space-between",
        paddingTop: adminButtonStyle.verticalPadding
            ? adminButtonStyle.verticalPadding
            : theme.spacing(4),
        paddingBottom: adminButtonStyle.verticalPadding
            ? adminButtonStyle.verticalPadding
            : theme.spacing(4),
        paddingRight: adminButtonStyle.horizontalPadding
            ? adminButtonStyle.horizontalPadding
            : theme.spacing(4),
        paddingLeft: adminButtonStyle.horizontalPadding
            ? adminButtonStyle.horizontalPadding
            : theme.spacing(4),
        backgroundColor: adminButtonStyle.backgroundColor
            ? convertThemeColor(adminButtonStyle.backgroundColor)
            : theme.palette.grey[100],
        borderTop: adminButtonStyle.borderColor
            ? "1px solid ".concat(convertThemeColor(adminButtonStyle.borderColor))
            : "1px solid ".concat(theme.palette.grey[400]),
        borderRadius: adminButtonStyle.borderRadius ? adminButtonStyle.borderRadius : "",
        "span, i": {
            color: adminButtonStyle.textColor ? convertThemeColor(adminButtonStyle.textColor) : ""
        },
        ":hover": {
            backgroundColor: adminButtonStyle.backgroundColorOnHover
                ? convertThemeColor(adminButtonStyle.backgroundColorOnHover)
                : "",
            "span, i": {
                color: adminButtonStyle.textColorOnHover
                    ? convertThemeColor(adminButtonStyle.textColorOnHover)
                    : ""
            }
        }
    })));
});

export { StyledKKeycloakCredentialAuthButton as default };
//# sourceMappingURL=index.styled.js.map
